import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { RiskIncidentPanelWebController } from '../controller/RiskIncidentPanelWebController';

export class RiskIncidentPanelWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: RiskIncidentPanelWebController,
    });
  }

  get incidentId(): string {
    return this.getAttribute('data-incident-id') || '';
  }

  set incidentId(incidentId: string) {
    this.setAttribute('data-incident-id', incidentId);
  }
}
